(function (appComponents) {

	appComponents.services.googleAnalytics = function (Components) {

		var googleAnalytics = {};

		Components.getControllerPrototype().extend(googleAnalytics);

		googleAnalytics.types = {

			pageView: function () {

				var pagesToExcludeFromSend = ["productDetails"];

				if (pagesToExcludeFromSend.indexOf(googleAnalytics._page.title) > -1) return;

				ga('set', 'page', googleAnalytics._page.path);
				ga('send', 'pageview');
			}

		};

		googleAnalytics.send = function (type) {
			if (type == null || googleAnalytics.types[type] == null) return;
			googleAnalytics.types[type]();
		};

		googleAnalytics.init = function () {
			ga('create', googleAnalytics._config.gaId, 'auto');
		};

		return googleAnalytics;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});